<template>
  <div id="app">
    <component
      :is="currentPage"
      :selectedLocation="selectedLocation"
      ref="leaderboard"
    />
  </div>
</template>

<script>
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import HomePage from './components/HomePage.vue';
import AdminPage from './components/AdminPage.vue';
import HostPage from './components/HostPage.vue';
import LoginPage from './components/LoginPage.vue';
import LeaderboardStandalone from './components/LeaderboardStandalone.vue';
import SelectOMaticTvDisplay from './components/SelectOMaticTvDisplay.vue';

export default {
  name: 'App',
  data() {
    return {
      currentPage: 'HomePage', // Default to HomePage
      user: null,
      userRoles: [],
      selectedLocation: null,
    };
  },
  components: {
    HomePage,
    AdminPage,
    HostPage,
    LoginPage,
    LeaderboardStandalone,
    SelectOMaticTvDisplay,
  },
  mounted() {
    this.initializeAuth();
  },
  methods: {
    initializeAuth() {
      const auth = getAuth();
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          this.user = user;
          await this.fetchUserRoles(user.uid);
          this.checkRoute();
        } else {
          this.user = null;
          this.userRoles = [];
          this.checkRoute(); // Ensure route checking even if not logged in
        }
      });
    },
    async fetchUserRoles(uid) {
      const db = getFirestore();
      const roleDoc = await getDoc(doc(db, 'roles', uid));
      if (roleDoc.exists()) {
        this.userRoles = roleDoc.data().role || [];
      } else {
        this.userRoles = [];
      }
    },
    checkRoute() {
      const path = window.location.pathname.toLowerCase();
      
      if (path === '/admin') {
        if (this.user && this.userRoles.includes('admin')) {
          this.currentPage = 'AdminPage';
        } else {
          this.currentPage = 'LoginPage';
        }
      } else if (path === '/host') {
        if (this.user && (this.userRoles.includes('host') || this.userRoles.includes('admin'))) {
          this.currentPage = 'HostPage';
        } else {
          this.currentPage = 'LoginPage';
        }
      } else if (path == '/logout'){
        this.logout();
      } else if (path === '/leaderboard') {
        this.currentPage = 'LeaderboardStandalone';
        this.selectedLocation = 'nwXEvZZp3FPjI7nPPNSo';
      } else if (path === '/selectomatic-tv') {
        const params = new URLSearchParams(window.location.search);
        this.selectedLocation = params.get('location') || '';
        this.currentPage = 'SelectOMaticTvDisplay';
      } else {
        // Allow access to HomePage without login
        this.currentPage = 'HomePage';
      }
    },
    logout() {
      const auth = getAuth();
      auth.signOut().then(() => {
        this.user = null;
        this.userRoles = [];
        localStorage.removeItem('teamId');
        localStorage.removeItem('location');
        localStorage.removeItem('date');
        this.currentPage = 'HomePage'; // Redirect to HomePage after logout
        window.location.href = '/'; // Reload the homepage
      });
    },
  },
};
</script>

<style>
/* Add any global styles here */
</style>
